export default __webpack_public_path__ + "static/media/Hair_6_M_C1.d184c286.svg";